import * as React from "react";
import { mergeOverrides } from "baseui";
import { Button } from "kanopi-components/Button";
import { WidthContainer } from "kw/util/ChatFlow/WidthContainer";

/* eslint-disable react/prop-types */
// TODO: Enable the proptype check next time when this file is changed

// TODO: Have Button make its own props known
type TButtonProps = React.ComponentProps<typeof Button>;

const buttonOverrides = {
  BaseButton: {
    style: ({ $theme }) => ({
      paddingTop: "12px",
      paddingBottom: "12px",
      [`@media screen and (max-width: ${$theme.breakpoints.medium}px)`]: {
        width: "100%",
      },
    }),
  },
};

// TODO: Make nicer HOC?: withDefaultProps(Button, { etc }) which also infers types
export const NavButton = (props: TButtonProps) => {
  const { overrides, ...restProps } = props;
  const mergedOverrides = mergeOverrides(buttonOverrides, overrides);

  return (
    <WidthContainer>
      <Button
        kind="primary"
        size={Button.SIZE.large}
        wide
        overrides={mergedOverrides}
        {...restProps}
      />
    </WidthContainer>
  );
};
